import { render } from "./modalLicenceData.vue?vue&type=template&id=44b5a324&scoped=true"
import script from "./modalLicenceData.vue?vue&type=script&lang=js"
export * from "./modalLicenceData.vue?vue&type=script&lang=js"

import "./modalLicenceData.vue?vue&type=style&index=0&id=44b5a324&lang=scss&scoped=true"
/* custom blocks */
import block0 from "@/locales/ru/components/modals/modal-licence-data.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fmodals%2FmodalLicenceData.vue&locale=ru"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locales/en/components/modals/modal-licence-data.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fmodals%2FmodalLicenceData.vue&locale=en"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44b5a324"]])

export default __exports__